  /**
 * User-facing messages for the Outlook add-in
 *
 * @deprecated Use useTranslation() hook from '../i18n/I18nProvider' instead
 * This file is kept for backward compatibility during migration
 */

import { getTranslations } from "../i18n";

// Helper to get current translations
const t = () => getTranslations();

export const ERROR_MESSAGES = {
  get ROOM_NO_EMAIL() { return t().errors.roomNoEmail; },
  get ROOM_ALREADY_BOOKED() { return t().errors.roomAlreadyBooked; },
  get BOOKING_FAILED() { return t().errors.bookingFailed; },
  get NETWORK_ERROR() { return t().errors.networkError; },
  get AUTH_ERROR() { return t().errors.authError; },
  get AUTH_REQUIRED() { return t().errors.authRequired; },
  get AUTH_FAILED() { return t().errors.authFailed; },
  get VALIDATION_ERROR() { return t().errors.validationError; },
  get UNKNOWN_ERROR() { return t().errors.unknownError; },
  get OUTLOOK_CONTEXT_UNAVAILABLE() { return t().errors.outlookContextUnavailable; },
  get OUTLOOK_NO_APPOINTMENT() { return t().errors.outlookNoAppointment; },
  get OUTLOOK_CANNOT_UPDATE_LOCATION() { return t().errors.outlookCannotUpdateLocation; },
  get OUTLOOK_CANNOT_ADD_ATTENDEE() { return t().errors.outlookCannotAddAttendee; },
  get OUTLOOK_CANNOT_STORE_DATA() { return t().errors.outlookCannotStoreData; },
} as const;

export const SUCCESS_MESSAGES = {
  get ROOM_ADDED() { return t().success.roomAdded; },
} as const;

export const UI_LABELS = {
  get ADD_ROOM() { return t().ui.addRoom; },
  get ADDING_ROOM() { return t().ui.addingRoom; },
  get ADD_ANOTHER_ROOM() { return t().ui.addAnotherRoom; },
  get DONE() { return t().ui.done; },
  get CLOSE() { return t().ui.close; },
  get VIEW_OTHER_ROOMS() { return t().ui.viewOtherRooms; },
  get SEARCH_ROOMS() { return t().ui.searchRooms; },
  get RECONNECT() { return t().ui.reconnect; },
  get ROOM_FREE() { return t().ui.roomFree; },
  get ROOM_BOOKED() { return t().ui.roomBooked; },
  get ROOM_ADDED_TITLE() { return t().ui.roomAddedTitle; },
  get ROOM_ADDED_DESCRIPTION() { return t().ui.roomAddedDescription; },
  get LOADING_APPOINTMENT() { return t().ui.loadingAppointment; },
  get FILTERS() { return t().ui.filters; },
  get MIN_CAPACITY() { return t().ui.minCapacity; },
  get EQUIPMENT() { return t().ui.equipment; },
  get NO_ROOMS_FOUND() { return t().ui.noRoomsFound; },
  get ADJUST_FILTERS() { return t().ui.adjustFilters; },
  get ROOM_FOUND() { return t().ui.roomFound; },
  get ROOMS_FOUND() { return t().ui.roomsFound; },
  get CAPACITY() { return t().ui.capacity; },
  get ATTENDEE() { return t().ui.attendee; },
  get ATTENDEES() { return t().ui.attendees; },
  get TABS_ROOMS() { return t().ui.tabsRooms; },
  get TABS_INSIGHTS() { return t().ui.tabsInsights; },
  get TABS_SHORTLIST() { return t().ui.tabsShortlist; },
  get MEETING_SUMMARY() { return t().ui.meetingSummary; },
  get INSIGHTS_TITLE() { return t().ui.insightsTitle; },
  get RECOMMENDED_ROOMS() { return t().ui.recommendedRooms; },
  get TIME_WINDOW() { return t().ui.timeWindow; },
  get NO_SHORTLIST() { return t().ui.noShortlist; },
  get RECOMMENDED_FOR_YOU() { return t().ui.recommendedForYou; },
  get REFINE_SEARCH() { return t().ui.refineSearch; },
  get PEOPLE() { return t().ui.people; },
  get ALL_ROOMS() { return t().ui.allRooms; },
  get LOADING_ROOMS() { return t().ui.loadingRooms; },
  get TRY_ADJUST_FILTERS() { return t().ui.tryAdjustFilters; },
  get NO_SUBJECT() { return t().ui.noSubject; },
  get ORGANIZER() { return t().ui.organizer; },
  get YOU() { return t().ui.you; },
  get LOCATION() { return t().ui.location; },
  get MORE() { return t().ui.more; },
  get CONFIRMED() { return t().ui.confirmed; },
  get CHANGE_ROOM() { return t().ui.changeRoom; },
  get CANCEL_RESERVATION() { return t().ui.cancelReservation; },
  get LOADING_RESERVATIONS() { return t().ui.loadingReservations; },
  get ERROR_LOADING_RESERVATIONS() { return t().ui.errorLoadingReservations; },
  get CURRENT_MEETING_RESERVATION() { return t().ui.currentMeetingReservation; },
  get NO_RESERVATIONS() { return t().ui.noReservations; },
  get NO_RESERVATIONS_DESCRIPTION() { return t().ui.noReservationsDescription; },
  get TABS_BOOK() { return t().ui.tabsBook; },
  get TABS_RESERVATIONS() { return t().ui.tabsReservations; },

  get CANCEL() { return t().ui.cancel; },
  get BOOKING_METHOD_TITLE() { return t().ui.bookingMethodTitle; },
  get BOOKING_METHOD_DESCRIPTION() { return t().ui.bookingMethodDescription; },
  get BOOKING_METHOD_ATTENDEE() { return t().ui.bookingMethodAttendee; },
  get BOOKING_METHOD_ATTENDEE_DESCRIPTION() { return t().ui.bookingMethodAttendeeDescription; },
  get BOOKING_METHOD_DESKARE() { return t().ui.bookingMethodDeskare; },
  get BOOKING_METHOD_DESKARE_DESCRIPTION() { return t().ui.bookingMethodDeskareDescription; },
  get ALL_OFFICES_LABEL() { return t().ui.allOfficesLabel; },
  get OFFICE() { return t().ui.office; },
  get SIGN_OUT() { return t().ui.signOut; },
  get SIGN_IN() { return t().ui.signIn; },
  get SIGNED_OUT_MESSAGE() { return t().ui.signedOutMessage; },
} as const;

// Error type to context message mapping
export const ERROR_CONTEXT_MESSAGES: Record<string, string> = {
  get conflict() { return ` ${t().errorContext.conflict}`; },
  get network() { return ` ${t().errorContext.network}`; },
  get auth() { return ` ${t().errorContext.auth}`; },
  get validation() { return ` ${t().errorContext.validation}`; },
};
